// extracted by mini-css-extract-plugin
export default {"container":"Summary-module__container--Q6v8B","mainStat":"Summary-module__mainStat--vw5ua","claimButton":"Summary-module__claimButton--Nk6SF"};